import { A4uAdDisplay as IconComponent } from '@adobe/react-spectrum-workflow/dist/AdDisplay.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function AdDisplay(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}